module.exports = __webpack_public_path__ + "img/mobileScreenFeature-3-2.ce8dfcb5.svg";